/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loss_Temp_DeltaInputs */



/**
* | output |
* | --- |
* | "Primary loss" |
*
* @param {Loss_Temp_DeltaInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const loss_temp_delta = /** @type {((inputs?: Loss_Temp_DeltaInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loss_Temp_DeltaInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Primary loss")
	return /** @type {LocalizedString} */ ("Perte du  primaire")
});